import { ReactNode } from 'react';

import MedeloopLogo from 'src/assets/medeloop-logo.png';

interface AppOverlayProps {
  children: ReactNode;
}

export function CompleteAccountCreationOverlay({ children }: AppOverlayProps) {
  return (
    <div className="flex w-screen h-screen bg-gray-950">
      <div className="flex flex-col py-8 px-6 bg-gray-950 w-full">
        <div className="flex">
          <img src={MedeloopLogo} alt="medeloop-logo" />
        </div>
        <div className="flex flex-col flex-1 justify-center items-center">
          <div className="bg-dark-subdued-background rounded-2xl p-4">{children}</div>
        </div>
      </div>
    </div>
  );
}
